/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions'
import * as ActionTypes from '@src/redux/actionTypes'
import * as AutocompleteQueryReducer from '@src/redux/reducers/autocomplete.query'
import { reducer as reducerNetworking } from '../networking'
import { getGraph } from '@src/utils/redux.tools'
import { defaultState, NetworksState } from './default.state'
import { isEmpty } from 'lodash'

export function reducer(
  state = defaultState,
  action: Actions.Networks.ActionTypes
): NetworksState {
  switch (action.type) {
    case ActionTypes.Networks.GET_STAT_SUCCESS: {
      return {
        ...state,
        [action.payload.stat]: action.payload.value,
        isPending: false
      }
    }
    case ActionTypes.Networks.GET_DETAIL_STAT_SUCCESS: {
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.stat]: action.payload.value
        },
        isPending: false
      }
    }
    case ActionTypes.Networks.GET_SUMMARY_NETWORK: {
      const { totals, overviewList } = action.payload
      return {
        ...state,
        totals,
        overviewList,
        isPending: false
      }
    }
    case ActionTypes.Networks.GET_NETWORKING_SUCCESS: {
      return {
        ...state,
        details: {
          ...state.details,
          networking: {
            ...state.details.networking,
            ...reducerNetworking(state.details.networking, action)
          }
        }
      }
    }
    case ActionTypes.Networks.GET_NETWORK_DETAILS: {
      const {
        info,
        user_count = 0,
        group_count = 0,
        role_count = 0,
        objects_total = 0,
        objects_used = 0,
        roles_used = 0,
        instances_count = 0,
        sg_count = 0,
        subnets_count = 0,
        ports_count = 0,
        routes_count = 0
      } = action.payload

      return {
        ...state,
        details: {
          ...state.details,
          ...AutocompleteQueryReducer.reducer(state.details, action),
          info: { ...defaultState.details.info, ...info },
          roleCounts: role_count,
          groupCounts: group_count,
          userCounts: user_count,
          membershipCounts: {
            ...state.details.membershipCounts,
            rolesUsed: roles_used,
            roles: role_count
          },
          objectCounts: {
            ...state.details.objectCounts,
            used: objects_used,
            total: objects_total
          },
          networkingCounts: {
            instancesCnt: instances_count,
            securityGroupsCnt: sg_count,
            subnetsCnt: subnets_count,
            sgRulesCnt: ports_count,
            routesCnt: routes_count
          }
        },
        isPending: false
      }
    }
    case ActionTypes.Networks.CLEANER_STAT: {
      if (!isEmpty(action.payload.stat)) {
        return {
          ...state,
          [action.payload.stat]: defaultState[action.payload.stat]
        }
      }
      return state
    }
    case ActionTypes.Networks.CLEANER_DETAIL_STAT: {
      if (!isEmpty(action.payload.stat)) {
        return {
          ...state,
          details: {
            ...state.details,
            [action.payload.stat]:
              AutocompleteQueryReducer.defaultState[action.payload.stat]
          }
        }
      }
      return state
    }
    case ActionTypes.Networks.SERVER_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors,
        isPending: action.payload.isPending,
        details: {
          ...state.details,
          isPendingGraph: false
        }
      }
    }
    case ActionTypes.Networks.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }
    case ActionTypes.Networks.REQUEST_PENDING_DETAIL_GRAPH: {
      return {
        ...state,
        details: {
          ...state.details,
          isPendingGraph: action.payload.isPending
        }
      }
    }

    case ActionTypes.Networks.DISPOSE_DETAILS: {
      return {
        ...state,
        details: defaultState.details,
        selectedGraphView: defaultState.selectedGraphView
      }
    }

    case ActionTypes.Networks.REQUEST_PENDING_GRAPH: {
      return {
        ...state,
        details: {
          ...state.details,
          isPendingGraph: action.payload.isPending
        }
      }
    }
    case ActionTypes.Networks.GET_DETAILS_GRAPH_SUCCESS: {
      const { graph } = action
      return {
        ...state,
        details: {
          ...state.details,
          ...getGraph({ state, graph })
        },
        isPending: false
      }
    }
    case ActionTypes.Networks.SET_SELECTED_TYPE: {
      return {
        ...state,
        selectedNetwork: action.payload.selectedNetwork
      }
    }
    case ActionTypes.Networks.GET_NETWORK_DETAILS_INFO: {
      const {
        info,
        user_count = 0,
        group_count = 0,
        role_count = 0,
        objects_total = 0,
        objects_used = 0,
        roles_used = 0,
        instances_count = 0,
        sg_count = 0,
        subnets_count = 0,
        ports_count = 0,
        routes_count = 0
      } = action.payload

      return {
        ...state,
        details: {
          ...state.details,
          info: { ...defaultState.details.info, ...info },
          roleCounts: role_count,
          groupCounts: group_count,
          userCounts: user_count,
          membershipCounts: {
            ...state.details.membershipCounts,
            rolesUsed: roles_used,
            roles: role_count
          },
          objectCounts: {
            ...state.details.objectCounts,
            used: objects_used,
            total: objects_total
          },
          networkingCounts: {
            instancesCnt: instances_count,
            securityGroupsCnt: sg_count,
            subnetsCnt: subnets_count,
            sgRulesCnt: ports_count,
            routesCnt: routes_count
          }
        },
        isPending: false
      }
    }
    case ActionTypes.Networks.GET_NETWORK_DETAILS_TABLE_DATA: {
      return {
        ...state,
        details: {
          ...state.details,
          ...AutocompleteQueryReducer.reducer(state.details, action)
        },
        isPending: false
      }
    }
    case ActionTypes.Networks.SET_NETWORK_DETAILS_ACTIVE_COUNTER: {
      return {
        ...state,
        details: {
          ...state.details,
          selectedCounter: action.payload.selectedCounter
        }
      }
    }
    default: {
      return state
    }
  }
}
